export default __webpack_public_path__ + "static/media/type-h3.576a5375.svg";